module.exports = "/_next/static/images/7efbfeb23bb26434343a60533f84f5b8-pj-person-making-card-purchase@0.5x.jpg";